'use client';
import { useState } from 'react';
import type { StockFactors } from '@/lib/compute';
import { QUALITY_FACTORS } from '@/lib/clientScore';
import { FactorRow } from './FactorRow';

interface Props {
  enabledFactors: Set<keyof StockFactors>;
  onToggleFactor: (key: keyof StockFactors) => void;
  highlightedFactor: keyof StockFactors | null | undefined;
  onFactorHighlight?: (key: keyof StockFactors) => void;
  infoKey: string | null;
  setInfoKey: (k: string | null) => void;
}

export function MomentumFactorsPanel({
  enabledFactors,
  onToggleFactor,
  highlightedFactor,
  onFactorHighlight,
  infoKey,
  setInfoKey,
}: Props) {
  const [open, setOpen] = useState(false);
  const factors = QUALITY_FACTORS.momentum;
  if (!factors) return null;

  return (
    <div className="px-5 py-2 border-b border-[#1e293b]">
      <button onClick={() => setOpen(!open)} className="flex items-center justify-between w-full cursor-pointer">
        <label className="text-[#e2e8f0] text-[10px] font-semibold uppercase tracking-widest cursor-pointer flex items-baseline gap-2">
          Momentum Factors
          <span className="text-[8px] font-normal normal-case" style={{ color: '#f59e0b' }}>Z-axis</span>
        </label>
        <svg className={`w-3 h-3 text-white transition-transform duration-150 ${open ? 'rotate-180' : ''}`}
          fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      {open && (
        <div className="mt-3 ml-4 flex flex-col gap-0">
          {factors.map(f => (
            <FactorRow
              key={f.key}
              factorKey={f.key}
              enabled={enabledFactors.has(f.key)}
              onToggle={() => onToggleFactor(f.key)}
              highlighted={highlightedFactor === f.key}
              onHighlight={() => onFactorHighlight?.(f.key as keyof StockFactors)}
              infoOpen={infoKey === f.key}
              onToggleInfo={() => setInfoKey(infoKey === f.key ? null : f.key)}
            />
          ))}
        </div>
      )}
    </div>
  );
}
